import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Sparkles, Heart } from 'lucide-react';
export function AboutSection() {
  return <section className="py-24 bg-parchment-light relative overflow-hidden" data-id="element-8">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-4 bg-gradient-to-b from-forest-dark/10 to-transparent" data-id="element-9" />
      <div className="absolute -left-32 -top-32 w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-10" />
      <div className="absolute -right-32 -bottom-32 w-96 h-96 bg-forest-light/5 rounded-full blur-3xl" data-id="element-11" />

      <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-13">
          <BookOpen className="w-12 h-12 text-gold mx-auto mb-6 opacity-80" data-id="element-14" />
          <h2 className="font-display text-4xl md:text-5xl text-forest-dark font-bold mb-6" data-id="element-15">
            Un Viaje hacia la Sanación Profunda
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full mb-8" data-id="element-16" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-17">
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="space-y-6 text-lg text-brown-light leading-relaxed" data-id="element-18">
            <p data-id="element-19">
              Basado en los revolucionarios descubrimientos de la{' '}
              <strong data-id="element-20">Nueva Medicina Germánica</strong>, este libro te invita a
              cambiar radicalmente tu percepción sobre la enfermedad y la salud.
            </p>
            <p data-id="element-21">
              A través de la comprensión de las Cinco Leyes Biológicas,
              descubrirás que lo que comúnmente llamamos "enfermedad" no es un
              error de la naturaleza, sino un{' '}
              <em data-id="element-22">Programa Biológico Especial y con Sentido</em>, creado para
              ayudarnos a sobrevivir ante un impacto emocional inesperado.
            </p>
            <p data-id="element-23">
              Aprende a escuchar a tu cuerpo, a identificar los conflictos
              ocultos detrás de tus síntomas y a transformar el dolor en una
              poderosa herramienta de conciencia y crecimiento personal.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="bg-parchment-dark p-8 rounded-2xl shadow-xl shadow-brown-dark/5 border border-gold/20 relative" data-id="element-24">
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gold/10 rounded-full blur-xl" data-id="element-25" />
            <h3 className="font-display text-2xl text-forest-dark font-semibold mb-6 flex items-center gap-3" data-id="element-26">
              <Sparkles className="w-6 h-6 text-gold" data-id="element-27" />
              Lo que descubrirás:
            </h3>
            <ul className="space-y-4" data-id="element-28">
              {['El origen emocional de los síntomas físicos', 'Las fases precisas de todo proceso biológico', 'El papel vital de los microorganismos en la curación', 'El sentido profundo detrás de cada enfermedad', 'Herramientas prácticas para tu bienestar'].map((item, index) => <li key={index} className="flex items-start gap-3 text-brown-dark" data-id="element-29">
                  <Heart className="w-5 h-5 text-gold shrink-0 mt-1" data-id="element-30" />
                  <span data-id="element-31">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}